import { useCallback, useState, type ReactNode } from "react";

import {AiCoachContext} from "@/hooks/useAiCoach";
export function AiCoachProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [pendingPrompt, setPendingPrompt] = useState<string | null>(null);
  const openCoach = useCallback((prompt?: string) => {
    const trimmed = typeof prompt === "string" && prompt.trim() ? prompt.trim() : null;
    setPendingPrompt(trimmed);
    setOpen(true);
  }, []);
  const closeCoach = useCallback(() => setOpen(false), []);
  const clearPrompt = useCallback(() => setPendingPrompt(null), []);

  return (
    <AiCoachContext.Provider value={{ open, pendingPrompt, openCoach, closeCoach, clearPrompt }}>
      {children}
    </AiCoachContext.Provider>
  );
}

